var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fixBasket" },
    [
      _vm.itemsCount > 0
        ? _c(
            "v-container",
            {
              staticClass: "pointer cc",
              on: {
                "&click": function ($event) {
                  return _vm.gotoCart.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "d-flex align-content-stretch" }, [
                _c("div", { staticClass: "leftPart" }, [
                  _c("div", { staticClass: "maxh d-flex align-center" }, [
                    !_vm.$store.getters.hidePrices
                      ? _c("div", { staticClass: "summe" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("price")(_vm.$store.getters.payerSum)
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("div", { staticClass: "rightPart" }, [
                  _c(
                    "div",
                    { staticClass: "maxh d-flex justify-end align-center" },
                    [
                      _c(
                        "v-badge",
                        {
                          staticClass: "mr-1",
                          attrs: {
                            color: "black",
                            content: _vm.itemsCount,
                            overlap: "",
                            "offset-x": "20",
                            "offset-y": "20",
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "rounded100",
                              attrs: { icon: "", dark: "", block: "" },
                              nativeOn: {
                                "&click": function ($event) {
                                  return _vm.gotoCart.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "myWhite",
                                  attrs: { left: "", medium: "" },
                                },
                                [_vm._v("mdi-cart-arrow-right")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "titleFont biggerFont ml-2 mr-1 baseColor ccPulsing",
                        },
                        [_vm._v("Zum Korb")]
                      ),
                      _c(
                        "v-icon",
                        {
                          staticClass: "baseColor myBase flex-shrink-0",
                          attrs: { medium: "" },
                        },
                        [_vm._v("mdi-chevron-right")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }